import { TEST_EMAILS } from '../constants';

export const isTestEmailForProd = (email: string) => {
  if (!email) {
    return false;
  }
  const lowerCaseEmail = email.toLowerCase();
  return TEST_EMAILS.includes(lowerCaseEmail);
};
